module.exports = __webpack_public_path__ + "img/menu-profile.e15ad00a.svg";